"use client"

import { Layout, LayoutProps } from "antd"
import { RefAttributes } from "react"

const Content = (props: LayoutProps & RefAttributes<HTMLElement>) => {
  return (
    <Layout.Content {...props} />
  )
}

export default Content